import React from 'react'; 
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';
 
const RowTablaSaldos = (props) => {
        const {saldo,index} = props; 
        let backColor = index % 2 != 0 ? ' backgroundTableLightBlue' : ''; 
        let saldoNegativo = false;
        let saldoTotalNegativo = false;

        if(saldo.Importe<0) saldoNegativo = true;
        if(saldo.Saldo<0) saldoTotalNegativo = true;

        let saldoImporte = saldo.Importe ? JSON.parse(JSON.stringify(GlobalHelper.ConversionDeMilesAgregandoDecimales(saldo.Importe))) : "";
        let saldoFinal = JSON.parse(JSON.stringify(GlobalHelper.ConversionDeMilesAgregandoDecimales(saldo.Saldo)));

        if(saldoNegativo){
            saldoImporte = saldoImporte.replace("-","(") 
            saldoImporte += ")"
        }  

        if(saldoTotalNegativo){
            saldoFinal = saldoFinal.replace("-","(")
            saldoFinal += ")"
        }
        
        return ( 
            <tr className={'BLock Personeria paddingLeftXS paddingTopBottom' + backColor}>
                <td style={{width:'110px'}}>
                    {saldo.Fecha.substr(0,10)}
                </td>
                <td style={{width:'424px'}}>
                    {saldo.Concepto}
                </td>
                <td style={{width:'100px',paddingLeft:'6px', alignContent:'left'}}>
                    {saldoImporte}
                </td>
                <td style={{width:'100px',paddingLeft:'13px', alignContent:'left'}}>
                    {saldoFinal}
                </td>
            </tr>
         );
      
}

export default RowTablaSaldos;